import { useEffect, useState } from 'react';
import calculateRateTotals from '../../functions/calculateRateTotals';

const useRateTotals = ({
  evaluatedRates,
  evaluatedCurrentRate,
  rateCostCalculator,
  gasolineCostCalculator,
  publicChargingElectricCostPerMonth,
  selectedEnergyCostIds,
  isComparingLowestRateOnly,
}) => {
  const [rateTotals, setRateTotals] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    let isMounted = true;
    setIsLoading(true);

    const fetchTotals = async () => {
      try {
        // Simulate async call with a delay
        await new Promise((resolve) => setTimeout(resolve, 20));
        const result = calculateRateTotals({
          rates: evaluatedRates,
          currentRate: evaluatedCurrentRate,
          rateCostCalculator,
          gasolineCostCalculator,
          publicChargingElectricCostPerMonth,
          selectedEnergyCostIds,
          isComparingLowestRateOnly,
        });
        if (isMounted) setRateTotals(result);
      } catch (e) {
        if (isMounted) setRateTotals([]);
      } finally {
        if (isMounted) setIsLoading(false);
      }
    };

    fetchTotals();

    return () => {
      isMounted = false;
    };
  }, [
    evaluatedRates,
    evaluatedCurrentRate,
    rateCostCalculator,
    gasolineCostCalculator,
    publicChargingElectricCostPerMonth,
    selectedEnergyCostIds,
    isComparingLowestRateOnly,
  ]);

  return { rateTotals, isLoading };
};

export default useRateTotals;
